import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import { Link } from "react-router-dom";
import longLeftArrow from "../../../assets/images/long-left-arrow.svg";
import { useTranslation } from "react-i18next";

function PageContentTitle(props) {
  const { t } = useTranslation();

  if (props.onBack) {
    return (
      <ButtonBase onClick={props.onBack} sx={{ textAlign: "left" }}>
        <Typography variant="h1" gutterBottom={false} sx={{ color: "primary.main" }}>
          <img src={longLeftArrow} alt={t("global.left_arrow_icon_alt")} /> {props.title}
        </Typography>
      </ButtonBase>
    );
  }

  if (props.titleLink) {
    return (
      <Link to={props.titleLink}>
        <Typography variant="h1" gutterBottom={false} sx={{ color: "primary.main", textDecoration: "none" }}>
          <img src={longLeftArrow} alt={t("global.left_arrow_icon_alt")} /> {props.title}
        </Typography>
      </Link>
    );
  }

  return (
    <Typography variant="h1" sx={{ color: "primary.main" }}>
      {props.title}
    </Typography>
  );
}

PageContentTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node.isRequired, PropTypes.string.isRequired]).isRequired,
  titleLink: PropTypes.string,
  onBack: PropTypes.func,
};
export default PageContentTitle;
